import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={61.599}
      height={97.261}
      viewBox="0 0 61.599 97.261"
      {...props}
    >
      <path
        data-name="Path 988"
        d="M24.315 1.625a6.483 6.483 0 016.484 6.484v61.6H17.835V8.105a6.484 6.484 0 016.48-6.48zm0 0"
        fill="#ffd782"
      />
      <path
        data-name="Path 989"
        d="M37.283 1.625a6.483 6.483 0 016.484 6.484v61.6H30.803V8.105a6.484 6.484 0 016.48-6.48zm0 0"
        fill="#f7bc54"
      />
      <g data-name="Group 121" fill="#e97424">
        <path
          data-name="Path 990"
          d="M9.726 38.904H1.621a1.621 1.621 0 010-3.242h8.105a1.621 1.621 0 010 3.242zm0 0"
        />
        <path
          data-name="Path 991"
          d="M9.722 32.42a1.624 1.624 0 01-.723-.17l-6.477-3.242a1.622 1.622 0 111.449-2.9l6.484 3.242a1.621 1.621 0 01-.727 3.072zm0 0"
        />
        <path
          data-name="Path 992"
          d="M3.242 48.63a1.621 1.621 0 01-.726-3.072L9 42.316a1.622 1.622 0 011.449 2.9l-6.484 3.242a1.628 1.628 0 01-.723.17zm0 0"
        />
        <path
          data-name="Path 993"
          d="M59.978 38.904h-8.105a1.621 1.621 0 010-3.242h8.105a1.621 1.621 0 010 3.242zm0 0"
        />
        <path
          data-name="Path 994"
          d="M51.872 32.42a1.621 1.621 0 01-.726-3.072l6.484-3.242a1.622 1.622 0 011.449 2.9l-6.484 3.242a1.628 1.628 0 01-.723.172zm0 0"
        />
        <path
          data-name="Path 995"
          d="M58.352 48.63a1.624 1.624 0 01-.723-.17l-6.484-3.242a1.622 1.622 0 111.449-2.9l6.484 3.242a1.621 1.621 0 01-.727 3.072zm0 0"
        />
      </g>
      <path
        data-name="Path 996"
        d="M37.283 71.325a1.621 1.621 0 01-1.621-1.621V24.315a1.621 1.621 0 113.242 0v45.389a1.621 1.621 0 01-1.621 1.621zm0 0"
        fill="#fff"
      />
      <path
        data-name="Path 997"
        d="M24.315 71.325a1.621 1.621 0 01-1.621-1.621V24.315a1.621 1.621 0 113.242 0v45.389a1.621 1.621 0 01-1.621 1.621zm0 0"
        fill="#fff"
      />
      <path
        data-name="Path 998"
        d="M24.315 19.452a1.621 1.621 0 01-1.621-1.621v-3.242a1.621 1.621 0 113.242 0v3.242a1.621 1.621 0 01-1.621 1.621zm0 0"
        fill="#fff"
      />
      <path
        data-name="Path 999"
        d="M37.283 19.452a1.621 1.621 0 01-1.621-1.621v-3.242a1.621 1.621 0 113.242 0v3.242a1.621 1.621 0 01-1.621 1.621zm0 0"
        fill="#fff"
      />
      <path
        data-name="Path 1000"
        d="M14.593 69.708h32.42v9.726h-32.42zm0 0"
        fill="#003586"
      />
      <path
        data-name="Path 1001"
        d="M21.077 79.434h19.452v9.726H21.077zm0 0"
        fill="#165a9f"
      />
      <path
        data-name="Path 1002"
        d="M22.698 89.16h16.21a6.484 6.484 0 01-6.484 6.484h-3.246a6.484 6.484 0 01-6.48-6.484zm0 0"
        fill="#003586"
      />
      <path
        data-name="Path 1003"
        d="M21.072 90.777h.162a8.12 8.12 0 007.943 6.484h3.242a8.12 8.12 0 007.944-6.484h.161a1.621 1.621 0 001.621-1.621v-8.105h4.863a1.621 1.621 0 001.621-1.621v-9.727a1.621 1.621 0 00-1.621-1.621h-1.62V8.103a8.081 8.081 0 00-14.589-4.811A8.081 8.081 0 0016.21 8.103v59.98h-1.621a1.621 1.621 0 00-1.617 1.62v9.726a1.621 1.621 0 001.621 1.621h4.859v8.105a1.621 1.621 0 001.62 1.622zm11.347 3.242h-3.241a4.872 4.872 0 01-4.585-3.242h12.413a4.873 4.873 0 01-4.586 3.242zm6.484-6.484H22.694v-6.484h16.21zm-1.62-84.293a4.862 4.862 0 014.863 4.861v59.98h-3.242V24.315a1.621 1.621 0 10-3.242 0v43.768H32.42V8.103a4.863 4.863 0 014.863-4.861zM19.452 8.103a4.863 4.863 0 119.726 0v59.98h-3.242V24.315a1.621 1.621 0 10-3.242 0v43.768h-3.242zm-3.242 63.22h29.178v6.484H16.21zm0 0"
      />
      <path
        data-name="Path 1004"
        d="M9.726 35.666H1.621a1.621 1.621 0 000 3.242h8.105a1.621 1.621 0 000-3.242zm0 0"
      />
      <path
        data-name="Path 1005"
        d="M9.002 32.258a1.622 1.622 0 001.449-2.9l-6.484-3.244a1.622 1.622 0 10-1.449 2.9zm0 0"
      />
      <path
        data-name="Path 1006"
        d="M9.002 42.316l-6.484 3.239a1.622 1.622 0 101.449 2.9l6.484-3.242a1.622 1.622 0 00-1.449-2.9zm0 0"
      />
      <path
        data-name="Path 1007"
        d="M61.598 37.283a1.621 1.621 0 00-1.621-1.617h-8.105a1.621 1.621 0 000 3.242h8.105a1.621 1.621 0 001.621-1.625zm0 0"
      />
      <path
        data-name="Path 1008"
        d="M51.872 32.42a1.628 1.628 0 00.723-.17l6.484-3.242a1.622 1.622 0 00-1.449-2.9l-6.484 3.242a1.621 1.621 0 00.726 3.072zm0 0"
      />
      <path
        data-name="Path 1009"
        d="M52.597 42.316a1.622 1.622 0 10-1.449 2.9l6.484 3.242a1.622 1.622 0 001.449-2.9zm0 0"
      />
      <path
        data-name="Path 1010"
        d="M24.315 19.452a1.621 1.621 0 001.621-1.621v-3.242a1.621 1.621 0 10-3.242 0v3.242a1.621 1.621 0 001.621 1.621zm0 0"
      />
      <path
        data-name="Path 1011"
        d="M37.283 19.452a1.621 1.621 0 001.621-1.621v-3.242a1.621 1.621 0 10-3.242 0v3.242a1.621 1.621 0 001.621 1.621zm0 0"
      />
    </svg>
  )
}

export default SvgComponent
